var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-info" }, [
    _c("div", { staticClass: "form-row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDevice.retailerComName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDevice.title))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDevice.brandName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDevice.catName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.getDevcGroupNameByCatId(_vm.shopDevice.catId)))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDevice.quantity))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDevice.theUnit))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.shopDevice.devcDefId == -1 ? "未关联" : "已关联"))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title" }, [_vm._v("耗材图片")]),
      _vm._v(" "),
      _vm.shopDevice.imageUrl != null && _vm.shopDevice.imageUrl.length > 0
        ? _c(
            "div",
            {
              staticClass: "content",
              staticStyle: { "padding-left": "126px" }
            },
            [
              _c("div", { staticClass: "file-area clearfix" }, [
                _c(
                  "div",
                  { staticClass: "file-item image viewable downloadable" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "file-content",
                        on: {
                          click: function($event) {
                            _vm.viewImage(_vm.shopDevice.imageUrl)
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: _vm.shopDevice.imageUrl } }),
                        _vm._v(" "),
                        _vm._m(8)
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        : _c("div", [_vm._v("无")])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构名称:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("耗材名称:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类分组：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("数量:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单位:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("关联定义:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "operation-group" }, [
      _c("i", { staticClass: "icon iconfont icon-chakan view" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7696efcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7696efcd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ShopDeviceLowCost/ShopDeviceLowCostDetail.vue
// module id = 3033
// module chunks = 0